import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950">
            准备好探索
            <br />
            韩漫世界了吗？
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-500 leading-relaxed">
            12,860+ 部漫画，每日 86 部更新，325,000+ 读者与你同行。
            <br />
            现在加入，发现属于你的下一部心头好。
          </p>
          <div className="mt-10">
            <Link
              to="/category/fantasy"
              className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-10 py-4 rounded-full text-base font-semibold whitespace-nowrap hover:bg-primary-600 transition-all duration-200 hover:scale-105"
            >
              立即开始阅读
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          </div>
        </div>

        <div className="mt-16 relative">
          <div className="bg-background-100 rounded-2xl p-6 md:p-10 overflow-hidden">
            <div className="flex justify-center gap-3 md:gap-4 flex-wrap">
              {[
                'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20thumbnail%20fantasy%20magic%20style%2C%20colorful%20illustration%2C%20clean%20background%2C%20professional%20comic%20cover&width=160&height=220&seq=cta-cover-01&orientation=portrait',
                'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20thumbnail%20romance%20love%20style%2C%20beautiful%20illustration%2C%20clean%20background%2C%20professional%20comic%20cover&width=160&height=220&seq=cta-cover-02&orientation=portrait',
                'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20thumbnail%20action%20adventure%20style%2C%20dynamic%20illustration%2C%20clean%20background%2C%20professional%20comic%20cover&width=160&height=220&seq=cta-cover-03&orientation=portrait',
                'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20thumbnail%20school%20comedy%20style%2C%20bright%20illustration%2C%20clean%20background%2C%20professional%20comic%20cover&width=160&height=220&seq=cta-cover-04&orientation=portrait',
                'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20thumbnail%20thriller%20mystery%20style%2C%20dark%20illustration%2C%20clean%20background%2C%20professional%20comic%20cover&width=160&height=220&seq=cta-cover-05&orientation=portrait',
                'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20thumbnail%20historical%20drama%20style%2C%20elegant%20illustration%2C%20clean%20background%2C%20professional%20comic%20cover&width=160&height=220&seq=cta-cover-06&orientation=portrait',
                'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20thumbnail%20sci-fi%20future%20style%2C%20futuristic%20illustration%2C%20clean%20background%2C%20professional%20comic%20cover&width=160&height=220&seq=cta-cover-07&orientation=portrait',
                'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20thumbnail%20horror%20supernatural%20style%2C%20moody%20illustration%2C%20clean%20background%2C%20professional%20comic%20cover&width=160&height=220&seq=cta-cover-08&orientation=portrait',
              ].map((url, i) => (
                <div
                  key={i}
                  className="w-20 md:w-24 h-28 md:h-32 rounded-lg overflow-hidden bg-background-200 hover:-translate-y-1 transition-transform duration-200"
                >
                  <img
                    src={url}
                    alt={`韩漫封面 ${i + 1}`}
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}